import z from 'zod';

import { PortalAuthHttpError } from '../error';
import Session from '../Session';

import { getMessageFromError } from './errorHelper';

const RefreshTokenResponse = z.object({
  token: z.string(),
});

type RefreshTokenResponse = z.infer<typeof RefreshTokenResponse>;

export async function refreshAuthToken(
  session: Session
): Promise<RefreshTokenResponse> {
  try {
    const client = session.getPortalApiClientOrThrow(
      'Error refreshing auth token - client not ready.'
    );

    const { data, error, response } = await client.untyped.POST(
      '/api/v1/refresh',
      {
        headers: {
          authorization: `Bearer ${session.getRefreshToken()}`,
        },
      }
    );

    if (!response.ok) {
      const message = getMessageFromError(error);
      throw new PortalAuthHttpError(
        message ?? 'Refreshing auth token failed.',
        response.status
      );
    }
    return RefreshTokenResponse.parse(data);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
